import { Box, Stack, Typography } from '@mui/material';
import amexLogo from '../../assets/amex.png';
import applePayLogo from '../../assets/apple_pay.svg';
import googlePayLogo from '../../assets/google_pay.png';
import masterCardLogo from '../../assets/mc_logo.svg';
import visaLogo from '../../assets/visa_logo.svg';

const paymentMethods = [
  { src: visaLogo, alt: 'Visa' },
  { src: masterCardLogo, alt: 'Mastercard' },
  { src: amexLogo, alt: 'American Express' },
  { src: applePayLogo, alt: 'Apple Pay' },
  { src: googlePayLogo, alt: 'Google Pay' },
];

const PaymentMethods = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 1.5,
      border: '1px solid #e5e7eb',
      borderRadius: 2,
      bgcolor: '#fff',
      px: 2,
      py: 1.5,
    }}
  >
    <Box sx={{ minWidth: 170, flex: '1 1 220px' }}>
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        Secure payment options
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Pay for your purchases with major cards and digital wallets at checkout.
      </Typography>
    </Box>
    <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap', alignItems: 'center' }}>
      {paymentMethods.map(({ src, alt }) => (
        <Box
          key={alt}
          sx={{
            width: 54,
            height: 34,
            display: 'grid',
            placeItems: 'center',
            border: '1px solid #e5e7eb',
            borderRadius: 1,
            p: 0.5,
            flexShrink: 0,
            overflow: 'hidden',
          }}
        >
          <Box component="img" src={src} alt={alt} sx={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </Box>
      ))}
    </Stack>
  </Box>
);

export default PaymentMethods;